exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-06e73be3] .invisible-placeholder .gray-background {\n  background-color: transparent;\n  cursor: initial;\n}\n[data-v-06e73be3] .invisible-placeholder .read-more-button-text {\n  background: transparent;\n}\n.links-preview--vertical .link-slide[data-v-06e73be3] {\n  margin-bottom: 2px;\n}\n.links-preview--vertical .link-slide[data-v-06e73be3]:last-child {\n    margin-bottom: 0;\n}\n", ""]);

// exports
